import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const SERVICE_REQUESTS_REQUEST = 'SERVICE_REQUESTS_REQUEST';
export const SERVICE_REQUESTS_SUCCESS = 'SERVICE_REQUESTS_SUCCESS';
export const SERVICE_REQUESTS_FAILURE = 'SERVICE_REQUESTS_FAILURE';

export const SERVICE_REQUEST_DETAILS_REQUEST = 'SERVICE_REQUEST_DETAILS_REQUEST';
export const SERVICE_REQUEST_DETAILS_SUCCESS = 'SERVICE_REQUEST_DETAILS_SUCCESS';
export const SERVICE_REQUEST_DETAILS_FAILURE = 'SERVICE_REQUEST_DETAILS_FAILURE';

export const SERVICE_REQUEST_CREATE_REQUEST = 'SERVICE_REQUEST_CREATE_REQUEST';
export const SERVICE_REQUEST_CREATE_SUCCESS = 'SERVICE_REQUEST_CREATE_SUCCESS';
export const SERVICE_REQUEST_CREATE_FAILURE = 'SERVICE_REQUEST_CREATE_FAILURE';

export const SERVICE_REQUEST_CREATE_NEW_REQUEST = 'SERVICE_REQUEST_CREATE_NEW_REQUEST';
export const SERVICE_REQUEST_CREATE_NEW_SUCCESS = 'SERVICE_REQUEST_CREATE_NEW_SUCCESS';
export const SERVICE_REQUEST_CREATE_NEW_FAILURE = 'SERVICE_REQUEST_CREATE_NEW_FAILURE';

export const SERVICE_REQUEST_UPDATE_REQUEST = 'SERVICE_REQUEST_UPDATE_REQUEST';
export const SERVICE_REQUEST_UPDATE_SUCCESS = 'SERVICE_REQUEST_UPDATE_SUCCESS';
export const SERVICE_REQUEST_UPDATE_FAILURE = 'SERVICE_REQUEST_UPDATE_FAILURE';

export const SERVICE_REQUEST_STATUSES_REQUEST = 'SERVICE_REQUEST_STATUSES_REQUEST';
export const SERVICE_REQUEST_STATUSES_SUCCESS = 'SERVICE_REQUEST_STATUSES_SUCCESS';
export const SERVICE_REQUEST_STATUSES_FAILURE = 'SERVICE_REQUEST_STATUSES_FAILURE';

export const SERVICE_OUTCOME_STATUSES_REQUEST = 'SERVICE_OUTCOME_STATUSES_REQUEST';
export const SERVICE_OUTCOME_STATUSES_SUCCESS = 'SERVICE_OUTCOME_STATUSES_SUCCESS';
export const SERVICE_OUTCOME_STATUSES_FAILURE = 'SERVICE_OUTCOME_STATUSES_FAILURE';

export const SERVICE_REQUEST_UPLOAD_FILES_REQUEST = 'SERVICE_REQUEST_UPLOAD_FILES_REQUEST';
export const SERVICE_REQUEST_UPLOAD_FILES_SUCCESS = 'SERVICE_REQUEST_UPLOAD_FILES_SUCCESS';
export const SERVICE_REQUEST_UPLOAD_FILES_FAILURE = 'SERVICE_REQUEST_UPLOAD_FILES_FAILURE';

export function requestServiceRequests(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests?${query}`,
      method: 'GET',
      types: ['SERVICE_REQUESTS_REQUEST', 'SERVICE_REQUESTS_SUCCESS', 'SERVICE_REQUESTS_FAILURE']
    }
  };
}

export function requestServiceRequestDetails(serviceRequestId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}?${query}`,
      method: 'GET',
      types: [
        { type: 'SERVICE_REQUEST_DETAILS_REQUEST', meta: { serviceRequestId } },
        { type: 'SERVICE_REQUEST_DETAILS_SUCCESS', meta: { serviceRequestId } },
        { type: 'SERVICE_REQUEST_DETAILS_FAILURE', meta: { serviceRequestId } },
      ]
    }
  }
}

export function requestServiceTypesByClient(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/types/byclient?${query}`,
      method: 'GET',
      types: ['SERVICE_TYPES_CLIENT_REQUEST', 'SERVICE_TYPES_CLIENT_SUCCESS', 'SERVICE_TYPES_CLIENT_FAILURE',]
    }
  }
}

export function createServiceRequest(serviceRequest, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests?${query}`,
      method: 'POST',
      body: JSON.stringify(serviceRequest),
      types: ["SERVICE_REQUEST_CREATE_REQUEST", "SERVICE_REQUEST_CREATE_SUCCESS", "SERVICE_REQUEST_CREATE_FAILURE"]
    }
  }
}

export function createServiceRequestNew(serviceRequest, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/new?${query}`,
      method: 'POST',
      body: JSON.stringify(serviceRequest),
      types: ["SERVICE_REQUEST_CREATE_NEW_REQUEST", "SERVICE_REQUEST_CREATE_NEW_SUCCESS", "SERVICE_REQUEST_CREATE_NEW_FAILURE"]
    }
  }
}

export function updateServiceRequest(serviceRequest, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequest.id}?${query}`,
      method: 'PUT',
      body: JSON.stringify(serviceRequest),
      types: ["SERVICE_REQUEST_UPDATE_REQUEST", "SERVICE_REQUEST_UPDATE_SUCCESS", "SERVICE_REQUEST_UPDATE_FAILURE"]
    }
  }
}

export function createServiceRequestAppointment(serviceRequestId, appointment, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}/appointment?${query}`,
      method: 'POST',
      body: JSON.stringify(appointment),
      types: ["SERVICE_REQUEST_APPT_CREATE_REQUEST", "SERVICE_REQUEST_APPT_CREATE_SUCCESS", "SERVICE_REQUEST_APPT_CREATE_FAILURE"]
    }
  }
}

export function updateServiceRequestAppointment(serviceRequestId, appointment, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}/appointment?${query}`,
      method: 'PUT',
      body: JSON.stringify(appointment),
      types: ["SERVICE_REQUEST_APPT_UPDATE_REQUEST", "SERVICE_REQUEST_APPT_UPDATE_SUCCESS", "SERVICE_REQUEST_APPT_UPDATE_FAILURE"]
    }
  }
}

export function deleteServiceRequest(serviceRequestId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}/deactivate?${query}`,
      method: 'PUT',
      types: ["SERVICE_REQUEST_DELETE_REQUEST", "SERVICE_REQUEST_DELETE_SUCCESS", "SERVICE_REQUEST_DELETE_FAILURE"]
    }
  }
}

export function requestPhoneTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/phonetypes?${query}`,
      method: 'GET',
      types: ['PHONE_TYPES_REQUEST', 'PHONE_TYPES_SUCCESS', 'PHONE_TYPES_FAILURE',]
    }
  }
}
export function requestServiceRequestStatuses(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/statuses?${query}`,
      method: 'GET',
      types: ['SERVICE_REQUEST_STATUSES_REQUEST', 'SERVICE_REQUEST_STATUSES_SUCCESS', 'SERVICE_REQUEST_STATUSES_FAILURE']
    }
  };
}

export function requestServiceOutcomeStatuses(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/outcome/statuses?${query}`,
      method: 'GET',
      types: ['SERVICE_OUTCOME_STATUSES_REQUEST', 'SERVICE_OUTCOME_STATUSES_SUCCESS', 'SERVICE_OUTCOME_STATUSES_FAILURE']
    }
  };
}

export function uploadServiceRequestFiles(serviceRequestId, params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('files', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}/files?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['SERVICE_REQUEST_UPLOAD_FILES_REQUEST', 'SERVICE_REQUEST_UPLOAD_FILES_SUCCESS', 'SERVICE_REQUEST_UPLOAD_FILES_FAILURE']
    },
  };

}

export function deleteServiceRequestFile(serviceRequestId, fileName, params) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}/files/${fileName}/?${query}`,
      method: 'DELETE',
      types: ['SERVICE_REQUEST_DELETE_FILE_REQUEST', 'SERVICE_REQUEST_DELETE_FILE_SUCCESS', 'SERVICE_REQUEST_DELETE_FILE_FAILURE']
    },
  };
}

export function requestWorkLocationsByClient(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/work-locations/byclient?${query}`,
      method: 'GET',
      types: ['WORK_LOCATIONS_CLIENT_REQUEST', 'WORK_LOCATIONS_CLIENT_SUCCESS', 'WORK_LOCATIONS_CLIENT_FAILURE',]
    }
  }
}

export function requestServiceLocationsByService(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/locations/byservice?${query}`,
      method: 'GET',
      types: ['SERVICE_LOCATIONS_REQUEST', 'SERVICE_LOCATIONS_SUCCESS', 'SERVICE_LOCATIONS_FAILURE',]
    }
  }
}

export function downloadServiceRequestFile(serviceRequestId, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/${serviceRequestId}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'SERVICE_REQUEST_DOWNLOAD_FILE_REQUEST',
        {
          type: 'SERVICE_REQUEST_DOWNLOAD_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'SERVICE_REQUEST_DOWNLOAD_FILE_FAILURE']
    },
  };
}

export function previewServiceRequestFile(serviceRequestId, params, fileName) {
  const query = $.param(params);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/service/requests/preview/${serviceRequestId}/files/${fileName}/?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'SERVICE_REQUEST_PREVIEW_FILE_REQUEST',
        {
          type: 'SERVICE_REQUEST_PREVIEW_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          },
        },
        'SERVICE_REQUEST_PREVIEW_FILE_FAILURE']
    }
  };
}

export function downloadServiceRequest(params) {
  const query = $.param(params, true);

  return {
    [RSAA]: {
    endpoint: `${TELEMETRY_API}organization/service/requests/export?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'DOWNLOAD_FILE_REQUEST',
        {
          type: 'DOWNLOAD_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'DOWNLOAD_FILE_FAILURE']
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/service-request-manager/ServiceRequestManagerActions.js